module.exports = __webpack_public_path__ + "static/media/tredence_logo.126f8b19.png";